const ZtudentView = () => {
    return (
        <>
            {/* <p className='Help__Title'>Vista del Ztudiante</p>
            <img src='/img/support/help/instructor/ztudent_view/1.png' className='Help__Image' />
            <p>¿Cómo funciona la <span className='Help__Text--Highlight'>Vista del Ztudiante</span>?</p>
            <p>Permite al instructor buscar a un Ztudiante y mostrar en tiempo real la pantalla en la que se encuentra dentro de Ztudia.</p>
            <p>Esta opción es útil para dar seguimiento, brindar asistencia inmediata y verificar el avance del Ztudiante en el curso.</p>
            <p className='Help__Text--Italic'>Accede para localizar al Ztudiante y visualizar su actividad actual.</p> */}
        </>
    )
}

export { ZtudentView };